module.exports = JSON.parse('{"Series is tracked":"Series is tracked","Series is untracked":"Series is untracked","Viewport":"Viewport"}')